export const SESSION_EXPIRED_EVENT = 'session-expired';

export function isTokenValid(token) {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload));
    return Number.isFinite(exp) && exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function readSession() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && isTokenValid(user.token)) {
      const normalized = { ...user, id: user.id ?? user.idusuario };
      delete normalized.idusuario;
      return normalized;
    }
  } catch {
    // Una sesión dañada requiere volver a iniciar sesión.
  }
  localStorage.removeItem('user');
  return null;
}

export function expireSession() {
  localStorage.removeItem('user');
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
}
